function parallax() {
    const parallax = document.querySelector('.parallax');
    if (parallax) {
        // setTimeout(function () {
            window.addEventListener('scroll', function () {
                const scrollY = window.scrollY;
                const speed = 0.5;
                const translateY = scrollY * speed;

                parallax.style.transform = `translateY(${translateY}px)`;
            });
        // }, 5);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    parallax();
});

